// Libraries
import styled from "styled-components"


export const VentureContainer = styled.div`

`

